import React from 'react';
import { Box, type BoxProps } from '@chakra-ui/react';

/** Standard inset border for elevated panels (exchange + money-move flows). */
export const SERVICE_FLOW_BORDER = 'rgba(255,255,255,0.08)';

/** Card / panel radius: flush on small screens, rounded from `md` up. */
export const SERVICE_CARD_BORDER_RADIUS = {
  base: 'none',
  md: 'lg',
} as const;

/**
 * Standard `Dialog.Content` surface — same tokens as ServiceFormCard.
 * Spread onto Chakra `Dialog.Content`, then add size/placement props (`mx`, `maxW`, etc.).
 */
export const SERVICE_DIALOG_CONTENT_PROPS = {
  bg: 'dark',
  color: 'body',
  borderWidth: '1px',
  borderColor: SERVICE_FLOW_BORDER,
  borderRadius: SERVICE_CARD_BORDER_RADIUS,
} as const;

export type ServiceFormCardProps = BoxProps & {
  children: React.ReactNode;
};

/**
 * Shared shell for Exchange-style forms: same tokens as Simple Trading card.
 * Use for deposit / withdraw / transfer tab bodies so layout stays consistent.
 */
const ServiceFormCard: React.FC<ServiceFormCardProps> = ({
  children,
  ...rest
}) => (
  <Box
    bg="dark"
    borderWidth="1px"
    borderColor={SERVICE_FLOW_BORDER}
    borderRadius={SERVICE_CARD_BORDER_RADIUS}
    w="100%"
    my={{ base: 4, xl: 6 }}
    px={{ base: 4, md: 6 }}
    pt={{ base: 5, md: 6 }}
    pb={{ base: 5, md: 6 }}
    {...rest}
  >
    {children}
  </Box>
);

export default ServiceFormCard;
